import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'
import BootError from './components/common/BootError'
import { sendClientLog } from './services/api'

// Версия точки входа — та же, что ?v= в index.html. Уходит в диагностику,
// чтобы по логам было видно, какая сборка у пострадавшего.
const APP_VERSION = 'v10'

// ─── П.3 task.txt: почему «мини-апп иногда не открывается» ────────────────
// Раньше SDK Telegram грузился СИНХРОННЫМ тегом в <head>: если telegram.org
// не отвечал (сеть/фильтрация), парсинг страницы вставал и пользователь видел
// белый экран. Теперь тег асинхронный (index.html), а ожидание SDK с таймаутом
// живёт здесь: не дождались — показываем понятный экран с кнопкой «Повторить»
// вместо пустоты, и пишем причину в диагностический лог.
const SDK_WAIT_MS = 4000

/** Отправить запись о сбое на бэкенд (POST /api/client-log → logs/client.log). */
function reportClient(stage, error) {
  try {
    sendClientLog({
      stage,
      message: error ? String(error?.message || error) : '',
      platform: window.Telegram?.WebApp?.platform || 'unknown',
      version: window.Telegram?.WebApp?.version || '',
      appVersion: APP_VERSION,
      hasInitData: !!window.Telegram?.WebApp?.initData,
      ua: navigator.userAgent,
    })
  } catch { /* диагностика не должна ломать загрузку */ }
}

// Ошибки, которые не поймал ErrorBoundary (сбои вне React: таймеры, промисы,
// обработчики событий) — тоже уходят в лог, иначе о них никто не узнает.
window.addEventListener('error', e => reportClient('window.error', e?.error || e?.message))
window.addEventListener('unhandledrejection', e => reportClient('unhandledrejection', e?.reason))

/** Дождаться SDK Telegram (window.Telegram.WebApp) или вернуть false по таймауту. */
function waitForTelegram(timeoutMs) {
  return new Promise(resolve => {
    if (window.Telegram?.WebApp) return resolve(true)
    const started = Date.now()
    const timer = setInterval(() => {
      if (window.Telegram?.WebApp) {
        clearInterval(timer)
        resolve(true)
      } else if (Date.now() - started >= timeoutMs) {
        clearInterval(timer)
        resolve(false)
      }
    }, 50)
  })
}

function render(node) {
  // Заглушка «Загрузка…» из index.html: React заменяет её своим деревом
  // при монтировании, отдельно чистить не нужно.
  createRoot(document.getElementById('root')).render(<StrictMode>{node}</StrictMode>)
}

function reload() {
  try { window.location.reload() } catch { /* ignore */ }
}

waitForTelegram(SDK_WAIT_MS).then(ok => {
  if (!ok) {
    // SDK так и не пришёл. Если открыто в обычном браузере, а не в Telegram,
    // это ожидаемо — приложение само покажет лендинг WebLanding (App.jsx
    // проверяет initData), но ждать 4 секунды незачем: рендерим сразу.
    const inTelegram = /Telegram/i.test(navigator.userAgent || '')
    if (inTelegram) {
      reportClient('sdk-timeout')
      render(<BootError titleKey="bootSdkFailed" hintKey="bootSdkFailedHint" onRetry={reload} />)
      return
    }
    render(<App />)
    return
  }

  // SDK на месте: штатная инициализация Telegram WebApp.
  try {
    window.Telegram.WebApp.ready()
    window.Telegram.WebApp.expand()
  } catch (e) {
    reportClient('telegram-init', e)
  }

  render(<App />)
})
